'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isDayVisible = {};

exports.__exports = isDayVisible;
